











































import {Component, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CTextField from '@/components/base/textField/CTextField.vue';
import CTable from '@/components/base/table/CTable.vue';
import CSelect from '@/components/base/select/CSelect.vue';
@Component({
    components: {CSelect, CTable, CTextField, CEditDialog},
})
export default class VeneerSpecieEditDialog extends Mixins(EditDialogMixin) {
    errorKeyList = {
        Name: 'Name',
    };

    get tableHeaders() {
        return [
            {
                value: 'IdWoodSpecie',
                text: this.$t('Catalogues.WoodSpecie.NameSingle'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.woodSpecie),
                ),
            },
        ];
    }
}
